import React from 'react';

const PageBody = (props) => (
    <div className="bottom">
        {props.children}
    </div>
);

export default PageBody